import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '#shared/components/UI';
import { usePermissionsContext } from './PermissionsContext';

type PermissionsSaveButtonProps = ComponentProps<typeof Button>;

/**
 * `Permissions.SaveButton`: submits the form through `form={formID}`, so it works from anywhere on the page
 * (a drawer footer, a side column). Disabled until there are valid changes; a host `disabled` (e.g. while
 * loading) only adds to that. Hidden in read-only mode.
 */
export default function PermissionsSaveButton({ disabled, ...props }: PermissionsSaveButtonProps) {
  const { editor, readOnly, formID } = usePermissionsContext();
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Permissions' });

  if (readOnly) return null;

  return (
    <Button
      type="submit"
      form={formID}
      colorScheme="primary"
      disabled={disabled || !editor.hasChanges || !editor.isValid}
      {...props}
    >
      {props.children ?? t('save', { defaultValue: 'Save Permissions' })}
    </Button>
  );
}
